import { css } from "@linaria/core";
import React from "react";
import { colors, spacings } from "@ui/Theme";
import Text from "@ui/Text";
import ConfidenceIndicator from "@ui/Indicator/Confidence";
import t from "../../../../../i18n";
import { StarFill } from "@ui/IconV2/react";

export const FaultInfoChartTooltip = ({
  type,
  failureDisplayName,
  description,
  confidence,
  amplitude,
  losses,
  isPromoted,
}: {
  type: "MANUAL_FAILURE" | "FAILURE";
  failureDisplayName: string | null;
  description: string | null;
  confidence: number | null | undefined;
  amplitude: string | null;
  losses: {
    value: string;
    qoi: string;
  } | null;
  isPromoted: boolean;
}) => (
  <div className={faultInfoChartTooltip}>
    <div className={nameConfidence}>
      <Text className={faultNameText} type="h4">
        {failureDisplayName}
      </Text>
      <div
        className={iconWrapper}
        title={
          isPromoted
            ? t("project.fault_event.side_panel.details.tooltip.fault_filter_type")
            : undefined
        }
      >
        {isPromoted && <StarFill className={starIcon} />}
        {confidence !== undefined && (
          <ConfidenceIndicator className={icon} value={confidence ?? 0} size="normal" />
        )}
      </div>
    </div>

    {description && (
      <Text className={descriptionCss} type="body2">
        {description}
      </Text>
    )}

    <ul className={listValue}>
      {type === "MANUAL_FAILURE" && (
        <li className={manualFailureColor}>
          <Text type="body1" as="p">
            {t("project.charts.tooltip.description.manual_failure")}
          </Text>
        </li>
      )}
      {losses && (
        <li>
          {t("commun.tooltip.label_value", {
            label: (
              <Text type="body1" as="span">
                {t("diagnosis.chart.tooltip.losses", { qoi: losses.qoi })}
              </Text>
            ),
            value: (
              <Text type="body1SemiBold" as="span">
                {losses.value}
              </Text>
            ),
          })}
        </li>
      )}
      {amplitude ? (
        <li>
          {t("commun.tooltip.label_value", {
            label: (
              <Text type="body1" as="span">
                {t("diagnosis.chart.tooltip.amplitude")}
              </Text>
            ),
            value: (
              <Text type="body1SemiBold" as="span">
                {amplitude}
              </Text>
            ),
          })}
        </li>
      ) : null}
    </ul>
  </div>
);

//#region
const nameConfidence = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${spacings.xxs};
`;

const faultNameText = css`
  color: ${colors.carbon900};
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: ${spacings.xxs};
`;

const starIcon = css`
  color: ${colors.phosphorus400};
  width: 14px;
  height: 14px;
  position: absolute;
  top: -8px;
  left: -2px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const icon = css`
  height: 18px;
  width: 18px;
`;

const manualFailureColor = css`
  color: ${colors.carbon800};
`;

const faultInfoChartTooltip = css`
  color: ${colors.carbon700};
`;

const descriptionCss = css`
  color: ${colors.carbon700};
`;

const listValue = css`
  display: flex;
  flex-direction: column;
  gap: ${spacings.xxs};
  flex-grow: 1;
  color: ${colors.carbon800};
  margin-top: ${spacings.xxs};
`;

const iconWrapper = css`
  display: flex;
  align-items: center;
  gap: ${spacings.s};
  flex-shrink: 0;
  position: relative;
`;
//#endregion
